<ng-container [formGroup]="form">
    <div [formGroupName]="question.groupName" [ngClass]="question.styles">
        @for (questionPart of question.questions; track trackByKey($index, questionPart); let isLast = $last; let isFirst = $first) {
            @switch (questionPart.controlType) {
                @case (CONTROL_TYPES.Dropdown) {
                    <mat-form-field
                        subscriptSizing="dynamic"
                        appearance="outline"
                        class="ca-form-field"
                        [class.with-label]="questionPart.label"
                        [ngClass]="questionPart.styles"
                        [hideRequiredMarker]="true"
                    >
                        @if (questionPart.label) {
                            <mat-label [attr.for]="questionPart.key">{{ questionPart.label | translate }}</mat-label>
                        }
                        <mat-select
                            [formControl]="countryControl"
                            [disableOptionCentering]="true"
                            [attr.data-testid]="questionPart.key"
                            panelClass="ca-dropdown-panel-class"
                        >
                            @for (option of $any(questionPart).options; track option) {
                                <mat-option
                                    [value]="option.value"
                                    [id]="questionPart.key + option.value"
                                    [attr.data-testid]="questionPart.key + option.value"
                                    >{{ option.key | translate }}</mat-option
                                >
                            }
                        </mat-select>
                    </mat-form-field>
                }
                @case (CONTROL_TYPES.Textbox) {
                    <mat-form-field
                        subscriptSizing="dynamic"
                        [hideRequiredMarker]="true"
                        appearance="outline"
                        class="ca-form-field"
                        [class.ca-highlight]="highlights[questionPart.key]"
                        [class.with-label]="questionPart.label"
                        [class.with-wrapped-hint]="highlights[questionPart.key]"
                        [class.with-wrapped-error-message]="isInvalid(questionPart) && isTouched(questionPart)"
                        [class.mb-2]="!(isInvalid(questionPart) && isTouched(questionPart))"
                        [ngClass]="questionPart.styles"
                    >
                        @if (questionPart.label) {
                            <mat-label [attr.for]="questionPart.key">{{ questionPart.label | translate }}</mat-label>
                        }
                        <input
                            [formControlName]="questionPart.key"
                            [placeholder]="(questionPart | as: TYPES.TextboxQuestion).placeholder | translate"
                            [id]="questionPart.key"
                            [attr.data-testid]="questionPart.key"
                            [type]="questionPart.type"
                            [mask]="(questionPart | as: TYPES.TextboxQuestion).mask.pattern"
                            [patterns]="$any(questionPart).mask?.customPatterns"
                            [decimalMarker]="$any(questionPart).mask?.decimalMarker"
                            [separatorLimit]="$any(questionPart).mask?.separatorLimit"
                            [dropSpecialCharacters]="
                                ($any(questionPart).mask?.dropSpecialCharacters | isNil)
                                    ? true
                                    : $any(questionPart).mask?.dropSpecialCharacters
                            "
                            [suffix]="
                                (questionPart | as: TYPES.TextboxQuestion).suffix
                                    ? ' ' + ((questionPart | as: TYPES.TextboxQuestion).suffix | translate)
                                    : ''
                            "
                            matInput
                        />
                        @if (isInvalid(questionPart) && isTouched(questionPart)) {
                            <mat-error>
                                <ca-form-error-message>
                                    {{ getErrorMessage(questionPart) | translate }}
                                </ca-form-error-message>
                            </mat-error>
                        }
                        @if (highlights[questionPart.key] && !(isInvalid(questionPart) && isTouched(questionPart))) {
                            <ca-icon icon="check" matSuffix class="ca-icon-s-16-p-0-f-16"></ca-icon>
                        }
                        @if (highlights[questionPart.key] && !(isInvalid(questionPart) && isTouched(questionPart))) {
                            <mat-hint>{{ (questionPart | as: TYPES.TextboxQuestion).conditionalHint | translate }}</mat-hint>
                        }
                    </mat-form-field>
                }
                @case (CONTROL_TYPES.Checkbox) {
                    <vp-checkbox class="w-full" [form]="formGroup" [question]="questionPart | as: TYPES.CheckboxQuestion"></vp-checkbox>
                }
                @case (CONTROL_TYPES.SearchDropdown) {
                    <vp-search-dropdown
                        class="w-full"
                        [highlight]="highlights[questionPart.key]"
                        [formGroup]="formGroup"
                        [formControlName]="(questionPart | as: TYPES.SearchDropdown).key"
                        [question]="questionPart | as: TYPES.SearchDropdown"
                        [minimalSearchValueLength]="1"
                    ></vp-search-dropdown>
                }
            }
        }
    </div>
</ng-container>
